module.exports = __webpack_public_path__ + "img/9788984143180.2c4d35e5.jpg";